(function(){
  var queued=false;
  var revealQueued=false;
  var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applySourceNavigation(){
    var overflow=document.querySelector('.shopify-section-group-header-group [data-testid="header-menu-overflow-list"]');
    if(!overflow)return false;
    if(typeof overflow.showAll!=='function')return false;
    try{overflow.showAll();}catch(error){return false;}
    overflow.querySelectorAll('[slot="overflow"]').forEach(function(item){
      item.removeAttribute('slot');
      item.removeAttribute('aria-hidden');
    });
    var more=overflow.querySelector('[slot="more"]');
    if(more){
      more.hidden=true;
      more.setAttribute('aria-hidden','true');
      more.style.setProperty('display','none','important');
    }
    overflow.removeAttribute('minimum-reached');
    var header=document.querySelector('#header-component');
    var touch=('ontouchstart' in window)&&navigator.maxTouchPoints>0;
    var menuStyle=window.innerWidth>=990&&!touch?'menu':'drawer';
    if(header&&header.dataset.menuStyle!==menuStyle)header.dataset.menuStyle=menuStyle;
    overflow.setAttribute('data-bv-source-nav','ready');
    return true;
  }

  function exposeSourceNavigation(){
    if(applySourceNavigation())return;
    if(window.customElements&&typeof window.customElements.whenDefined==='function'){
      window.customElements.whenDefined('overflow-list').then(function(){
        requestAnimationFrame(function(){
          applySourceNavigation();
          requestAnimationFrame(applySourceNavigation);
        });
      });
    }
  }

  function queueNavigation(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){
      queued=false;
      exposeSourceNavigation();
    });
  }

  function setupNavigationGuard(){
    var group=document.querySelector('#header-group');
    if(!group||group.__bvNavGuard)return;
    group.__bvNavGuard=true;
    var observer=new MutationObserver(function(){
      var overflow=group.querySelector('[data-testid="header-menu-overflow-list"]');
      if(!overflow)return;
      var hasOverflow=overflow.querySelector('[slot="overflow"]');
      var more=overflow.querySelector('[slot="more"]');
      var moreVisible=more&&!more.hidden&&more.style.display!=='none';
      var header=group.querySelector('#header-component');
      var touch=('ontouchstart' in window)&&navigator.maxTouchPoints>0;
      var wrongDesktopMode=window.innerWidth>=990&&!touch&&header&&header.dataset.menuStyle!=='menu';
      if(hasOverflow||moreVisible||overflow.hasAttribute('minimum-reached')||wrongDesktopMode)queueNavigation();
    });
    observer.observe(group,{subtree:true,attributes:true,attributeFilter:['slot','hidden','minimum-reached','data-menu-style'],childList:true});
  }

  function setupHeaderMotion(){
    var group=document.querySelector('#header-group');
    if(!group||group.__bvHeaderMotionReady)return;
    group.__bvHeaderMotionReady=true;
    var last=null;
    function sync(){
      var wrapper=document.querySelector('.page-wrapper');
      var next=Math.max(window.scrollY,wrapper?wrapper.scrollTop:0)>28;
      if(next===last)return;
      last=next;
      group.classList.toggle('bv-scrolled',next);
    }
    sync();
    window.addEventListener('scroll',sync,{passive:true});
    var wrapper=document.querySelector('.page-wrapper');
    if(wrapper)wrapper.addEventListener('scroll',sync,{passive:true});
  }

  function animateActivePanel(root){
    var panel=root.querySelector('.bv-panel.is-active');
    if(!panel)return;
    panel.classList.remove('bv-panel-enter');
    void panel.offsetWidth;
    panel.classList.add('bv-panel-enter');
    window.setTimeout(function(){panel.classList.remove('bv-panel-enter');},720);
  }

  function setupTabs(){
    document.querySelectorAll('[data-bv-tabs]').forEach(function(root){
      if(root.__bvTabsReady)return;
      root.__bvTabsReady=true;
      root.addEventListener('click',function(event){
        var button=event.target.closest('[data-bv-tab]');
        if(!button)return;
        window.setTimeout(function(){animateActivePanel(root);},0);
      });
      var observer=new MutationObserver(function(mutations){
        var changed=mutations.some(function(m){
          var wasActive=(' '+(m.oldValue||'')+' ').indexOf(' is-active ')!==-1;
          return !wasActive&&m.target.classList.contains('is-active');
        });
        if(changed)animateActivePanel(root);
      });
      root.querySelectorAll('.bv-panel').forEach(function(panel){observer.observe(panel,{attributes:true,attributeOldValue:true,attributeFilter:['class']});});
    });
  }

  function setupCollectionFilters(){
    var root=document.querySelector('#MainContent[data-template^="collection"]');
    if(!root)return;
    var form=root.querySelector('.facets--horizontal .facets__form')||root.querySelector('form.facets__form');
    if(!form||form.querySelector('.bv-filter-trigger'))return;
    var nativeToggle=root.querySelector('.facets-toggle__button');
    if(!nativeToggle)return;
    var button=document.createElement('button');
    button.type='button';
    button.className='bv-filter-trigger';
    button.setAttribute('aria-label','Open filters');
    button.innerHTML='<b aria-hidden="true">+</b><span>FILTERS</span>';
    button.addEventListener('click',function(){nativeToggle.click();});
    form.prepend(button);
  }

  function setupCollectionFilterGuard(){
    var root=document.querySelector('#MainContent[data-template^="collection"]');
    if(!root||root.__bvFilterGuard)return;
    root.__bvFilterGuard=true;
    var observer=new MutationObserver(function(){
      setupCollectionFilters();
      queueReveal();
    });
    observer.observe(root,{childList:true,subtree:true});
  }

  function setupRevealMotion(){
    if(reduceMotion)return;
    var sectionSelector='main[data-template="index"] .bv-home-tabs,main[data-template="index"] .bv-collector--source,main[data-template="index"] .bv-exclusive--source,main[data-template="index"] .bv-best-seller--source,main[data-template="index"] .bv-product-row,main[data-template="index"] .bv-category-strip,main[data-template="index"] .bv-explore,main[data-template="index"] .bv-reviews,main[data-template="index"] .bv-always-clean,#MainContent[data-template^="product"] .product-information__media,#MainContent[data-template^="product"] .product-details,#MainContent[data-template^="product"] .bv-best-seller--source,#MainContent[data-template^="product"] .bv-his-hers,#MainContent[data-template^="product"] .product-recommendations';
    var cardSelector='main[data-template="index"] .bv-home-tabs__grid .bv-card,main[data-template="index"] .bv-product-row__grid .bv-card,main[data-template="index"] .bv-always-clean__grid .bv-card,#MainContent[data-template^="collection"] .product-grid__item,#MainContent[data-template^="collection"] .bv-collection-promo,#MainContent[data-template^="product"] .product-recommendations .resource-list__item';
    var sections=Array.prototype.slice.call(document.querySelectorAll(sectionSelector));
    var cards=Array.prototype.slice.call(document.querySelectorAll(cardSelector));
    if(!sections.length&&!cards.length)return;

    sections.forEach(function(el){el.classList.add('bv-reveal');});
    cards.forEach(function(card,index){
      card.classList.add('bv-card-reveal');
      if(!card.style.getPropertyValue('--bv-delay'))card.style.setProperty('--bv-delay',(index%4)*55+'ms');
    });
    document.documentElement.classList.add('bv-motion-ready');

    var pending=sections.concat(cards).filter(function(el){return !el.classList.contains('bv-in');});
    if(!pending.length)return;
    if(!('IntersectionObserver' in window)){
      pending.forEach(function(el){el.classList.add('bv-in');});
      return;
    }
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('bv-in');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:0.08,rootMargin:'0px 0px -7% 0px'});
    pending.forEach(function(el){observer.observe(el);});
  }

  function queueReveal(){
    if(revealQueued)return;
    revealQueued=true;
    requestAnimationFrame(function(){
      revealQueued=false;
      setupRevealMotion();
    });
  }

  function init(){
    queueNavigation();
    if(window.customElements&&typeof window.customElements.whenDefined==='function'){
      window.customElements.whenDefined('overflow-list').then(function(){window.setTimeout(queueNavigation,0);});
    }
    [60,160,320,650,1100,1700].forEach(function(ms){window.setTimeout(queueNavigation,ms);});
    setupNavigationGuard();
    setupHeaderMotion();
    setupTabs();
    setupCollectionFilters();
    setupCollectionFilterGuard();
    queueReveal();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('resize',queueNavigation,{passive:true});
  window.addEventListener('pageshow',function(){queueNavigation();setupCollectionFilters();queueReveal();},{passive:true});
  document.addEventListener('shopify:section:load',function(){queueNavigation();setupNavigationGuard();setupTabs();setupCollectionFilters();setupCollectionFilterGuard();queueReveal();});
  document.addEventListener('shopify:block:select',queueNavigation);
})();

;(()=>{const init=()=>{document.querySelectorAll('.bv-comparison input').forEach(input=>{input.addEventListener('input',()=>input.parentElement.style.setProperty('--split',input.value+'%'));});document.querySelectorAll('.bv-home-tabs__grid,.bv-product-row__grid').forEach(grid=>{if(grid.nextElementSibling?.classList.contains('bv-rail-buttons'))return;const controls=document.createElement('div');controls.className='bv-rail-buttons';[-1,1].forEach(direction=>{const button=document.createElement('button');button.type='button';button.textContent=direction<0?'←':'→';button.setAttribute('aria-label',(document.documentElement.lang==='ar'?(direction<0?'المنتجات السابقة':'المنتجات التالية'):document.documentElement.lang==='fr'?(direction<0?'Produits précédents':'Produits suivants'):(direction<0?'Previous products':'Next products')));button.addEventListener('click',()=>grid.scrollBy({left:direction*grid.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));controls.append(button)});grid.after(controls)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init)})();

